(function () {
  'use strict';

  if (window.PTVTrainingProgramRecommender) {
    window.PTVTrainingProgramRecommender.initAll();
    return;
  }

  var rootSelector = '[data-training-program-recommender]';

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function parseConfig(root) {
    var configScript = root.querySelector('[data-training-program-recommender-config]');

    if (!configScript) {
      return { results: {} };
    }

    try {
      return JSON.parse(configScript.textContent);
    } catch (error) {
      return { results: {} };
    }
  }

  function getCheckedAnswer(root, key) {
    return root.querySelector('[data-tpr-answer="' + key + '"]:checked');
  }

  function collectAnswers(root) {
    var answers = {};
    var goal = getCheckedAnswer(root, 'goal');
    var experience = getCheckedAnswer(root, 'experience');
    var gender = getCheckedAnswer(root, 'gender');
    var focus = getCheckedAnswer(root, 'focus');

    answers.goal = goal ? goal.value : '';
    answers.experience = experience ? experience.value : '';
    answers.gender = gender ? gender.value : '';
    answers.focus = focus ? focus.value : '';

    return answers;
  }

  function getStepAnswer(step) {
    return step.querySelector('input[type="radio"]:checked');
  }

  function allStepsAnswered(state) {
    return state.steps.every(function (step) {
      return !!getStepAnswer(step);
    });
  }

  function determineResults(answers) {
    // Priority order mirrors the required recommendation rules.
    if (answers.experience === 'none') {
      return ['homebody', 'rookie'];
    }

    if (answers.experience === '0-2') {
      return ['rookie', 'strongMuscle'];
    }

    if (answers.gender === 'female') {
      return ['toughWoman', 'strongMuscle'];
    }

    if (answers.goal === 'fat-loss') {
      return ['getShredded', 'strongMuscle'];
    }

    if (answers.goal === 'functional') {
      return ['policeFirefighter'];
    }

    if (answers.goal === 'muscle' && answers.experience === '2-4') {
      return ['strongMuscle', 'getHuge1'];
    }

    if (answers.goal === 'muscle' && answers.experience === '5-plus' && answers.focus === 'general') {
      return ['getHuge1', 'strongMuscle'];
    }

    if (answers.goal === 'muscle' && answers.experience === '5-plus' && answers.focus === 'chest') {
      return ['hugeChest', 'getHuge1'];
    }

    if (answers.goal === 'muscle' && answers.experience === '5-plus' && answers.focus === 'arms') {
      return ['armBlaster', 'getHuge1'];
    }

    if (answers.goal === 'muscle' && answers.experience === '5-plus' && answers.focus === 'legs') {
      return ['legDestroyer', 'getHuge1'];
    }

    if (answers.goal === 'muscle' && answers.experience === '5-plus' && answers.focus === 'back') {
      return ['backAttack', 'getHuge1'];
    }

    return ['strongMuscle', 'getHuge1'];
  }

  function updateButtons(state) {
    state.steps.forEach(function (step) {
      var nextButton = step.querySelector('[data-tpr-next]');

      if (nextButton) {
        nextButton.disabled = !getStepAnswer(step);
      }
    });
  }

  function updateProgress(state, isResult) {
    var stepCount = state.progressSteps.length || state.steps.length;
    var currentIndex = isResult ? stepCount - 1 : state.activeStep;
    var hasAllAnswers = allStepsAnswered(state);
    var percent = ((currentIndex + 1) / stepCount) * 100;

    if (state.progressBar) {
      state.progressBar.style.width = percent + '%';
    }

    state.progressSteps.forEach(function (item, index) {
      var target = item.getAttribute('data-tpr-progress-target');
      var targetIndex = parseInt(target, 10);
      var isQuestionStep = !isNaN(targetIndex) && !!state.steps[targetIndex];
      var isResultStep = target === 'result';
      var hasAnswer = isQuestionStep && !!getStepAnswer(state.steps[targetIndex]);
      var isCurrent = index === currentIndex;
      var isComplete = isQuestionStep ? hasAnswer && !isCurrent : index < currentIndex;
      var canNavigate = isQuestionStep ? (targetIndex <= state.activeStep || hasAnswer) : isResultStep && hasAllAnswers;

      item.classList.toggle('is-current', isCurrent);
      item.classList.toggle('is-complete', isComplete);
      item.classList.toggle('is-available', canNavigate);
      item.disabled = !canNavigate;
      item.setAttribute('aria-disabled', canNavigate ? 'false' : 'true');

      if (isCurrent) {
        item.setAttribute('aria-current', 'step');
      } else {
        item.removeAttribute('aria-current');
      }
    });
  }

  function advance(state) {
    if (!getStepAnswer(state.steps[state.activeStep])) {
      state.steps[state.activeStep].classList.add('has-error');
      updateButtons(state);
      return;
    }

    if (state.activeStep < state.steps.length - 1) {
      renderStep(state, state.activeStep + 1, true);
    } else {
      showResult(state);
    }
  }

  function navigateToProgressTarget(state, progressStep) {
    var target = progressStep.getAttribute('data-tpr-progress-target');
    var targetIndex = parseInt(target, 10);

    if (progressStep.disabled) {
      return;
    }

    if (target === 'result') {
      if (allStepsAnswered(state)) {
        showResult(state);
      }

      return;
    }

    if (!isNaN(targetIndex) && state.steps[targetIndex]) {
      renderStep(state, targetIndex, true);

      if (state.status) {
        state.status.textContent = 'Siirrytty kysymykseen ' + (targetIndex + 1) + ' / ' + state.steps.length + '.';
      }
    }
  }

  function focusStep(step) {
    window.setTimeout(function () {
      step.focus();
    }, 40);
  }

  function renderStep(state, index, shouldFocus) {
    state.activeStep = index;

    state.steps.forEach(function (step, stepIndex) {
      var isActive = stepIndex === index;
      step.hidden = !isActive;
      step.classList.toggle('is-active', isActive);
      step.classList.remove('has-error');
    });

    if (state.result) {
      state.result.hidden = true;
      state.result.classList.remove('is-active');
    }

    updateProgress(state, false);
    updateButtons(state);

    if (shouldFocus && state.steps[index]) {
      focusStep(state.steps[index]);
    }
  }

  function setText(element, value) {
    if (element) {
      element.textContent = value || '';
    }
  }

  function createResultCard(resultData, index, ctaLabel) {
    var card = document.createElement('article');
    var media = document.createElement('div');
    var body = document.createElement('div');
    var kicker = document.createElement('span');
    var title = document.createElement('h4');
    var reason = document.createElement('p');
    var link = document.createElement('a');

    card.className = 'training-program-recommender__result-card';
    media.className = 'training-program-recommender__result-card-media';
    body.className = 'training-program-recommender__result-card-body';
    kicker.className = 'training-program-recommender__result-card-kicker';
    title.className = 'training-program-recommender__result-card-title';
    reason.className = 'training-program-recommender__result-card-reason';
    link.className = 'btn btn--small';

    kicker.textContent = index === 0 ? 'Ensisijainen suositus' : 'Toinen suositus';
    title.textContent = resultData.title || '';
    reason.textContent = resultData.reason || '';
    link.href = resultData.url || '#';
    link.textContent = ctaLabel || 'Tutustu ohjelmaan';

    if (resultData.image && resultData.image.src) {
      var image = document.createElement('img');
      image.src = resultData.image.src;
      image.alt = resultData.image.alt || resultData.title || '';
      image.loading = 'lazy';
      image.width = 900;
      image.height = 900;
      media.appendChild(image);
    } else {
      var placeholder = document.createElement('div');
      placeholder.className = 'training-program-recommender__image-placeholder';
      placeholder.textContent = 'Tuotekuva latautuu, kun suositus on valmis.';
      media.appendChild(placeholder);
    }

    body.appendChild(kicker);
    body.appendChild(title);
    body.appendChild(reason);
    body.appendChild(link);
    card.appendChild(media);
    card.appendChild(body);

    return card;
  }

  function showResult(state) {
    var answers = collectAnswers(state.root);
    var resultKeys = determineResults(answers);
    var resultItems = resultKeys
      .map(function (key) {
        return state.config.results[key];
      })
      .filter(function (resultData) {
        return !!resultData;
      });

    if (!resultItems.length) {
      return;
    }

    state.steps.forEach(function (step) {
      step.hidden = true;
      step.classList.remove('is-active');
    });

    setText(state.resultTitle, state.config.resultTitle || 'Suositellut ohjelmat');
    setText(state.resultReason, state.config.resultIntro || 'Valitsimme sinulle kaksi ohjelmaa, jotka tukevat tavoitettasi ja treenitaustaasi.');

    if (state.resultList) {
      state.resultList.innerHTML = '';
      state.resultList.classList.toggle('is-single', resultItems.length === 1);
      resultItems.slice(0, 2).forEach(function (resultData, index) {
        state.resultList.appendChild(createResultCard(resultData, index, state.config.ctaLabel));
      });
    }

    if (state.result) {
      state.result.hidden = false;
      state.result.classList.add('is-active');
      window.setTimeout(function () {
        state.result.focus();
      }, 40);
    }

    updateProgress(state, true);

    if (state.status) {
      state.status.textContent = 'Suositukset valmiit: ' + resultItems.map(function (item) { return item.title; }).join(' ja ') + '.';
    }
  }

  function reset(state) {
    if (state.form) {
      state.form.reset();
    }

    if (state.resultList) {
      state.resultList.innerHTML = '';
      state.resultList.classList.remove('is-single');
    }

    if (state.status) {
      state.status.textContent = 'Kysely aloitettu alusta.';
    }

    renderStep(state, 0, true);
  }

  function init(root) {
    if (!root || root.dataset.tprInitialized === 'true') {
      return;
    }

    var state = {
      root: root,
      form: root.querySelector('[data-tpr-form]'),
      config: parseConfig(root),
      activeStep: 0,
      steps: toArray(root.querySelectorAll('[data-tpr-step]')),
      progressSteps: toArray(root.querySelectorAll('[data-tpr-progress-step]')),
      progressBar: root.querySelector('[data-tpr-progress-bar]'),
      result: root.querySelector('[data-tpr-result]'),
      resultTitle: root.querySelector('[data-tpr-result-title]'),
      resultReason: root.querySelector('[data-tpr-result-reason]'),
      resultList: root.querySelector('[data-tpr-result-list]'),
      status: root.querySelector('[data-tpr-status]')
    };

    if (!state.form || !state.steps.length) {
      return;
    }

    root.dataset.tprInitialized = 'true';

    root.addEventListener('change', function (event) {
      var target = event.target;

      if (!target || !target.matches || !target.matches('[data-tpr-answer]')) {
        return;
      }

      var step = target.closest('[data-tpr-step]');

      if (step) {
        step.classList.remove('has-error');
      }

      updateButtons(state);

      window.setTimeout(function () {
        if (state.steps[state.activeStep] === step) {
          advance(state);
        }
      }, 140);
    });

    root.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target : event.target.parentElement;

      if (!target || !target.closest) {
        return;
      }

      var progressStep = target.closest('[data-tpr-progress-step]');

      if (progressStep) {
        event.preventDefault();
        navigateToProgressTarget(state, progressStep);
        return;
      }

      var option = target.closest('.training-program-recommender__option');
      var selectedAnswer = target.closest('[data-tpr-answer]');

      if (!selectedAnswer && option) {
        selectedAnswer = option.querySelector('[data-tpr-answer]');
      }

      if (
        selectedAnswer &&
        state.steps[state.activeStep] &&
        state.steps[state.activeStep].contains(selectedAnswer) &&
        selectedAnswer.checked
      ) {
        window.setTimeout(function () {
          if (state.steps[state.activeStep] && state.steps[state.activeStep].contains(selectedAnswer)) {
            advance(state);
          }
        }, 140);
      }

      var nextButton = target.closest('[data-tpr-next]');
      var backButton = target.closest('[data-tpr-back]');
      var resetButton = target.closest('[data-tpr-reset]');

      if (nextButton) {
        event.preventDefault();
        advance(state);
      }

      if (backButton) {
        event.preventDefault();

        if (state.activeStep > 0) {
          renderStep(state, state.activeStep - 1, true);
        }
      }

      if (resetButton) {
        event.preventDefault();
        reset(state);
      }
    });

    renderStep(state, 0, false);
  }

  function initAll(container) {
    var scope = container || document;
    toArray(scope.querySelectorAll(rootSelector)).forEach(init);
  }

  window.PTVTrainingProgramRecommender = {
    init: init,
    initAll: initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
}());
